import React from "react";
import { X, Play, Pause, Library, ShoppingBag, Ticket } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function CollectionSheet() {
  const { showCollection, setShowCollection, collection, current, playing, playSong, subscribed, artist, tickets, setTicketQR } = useApp();
  if (!showCollection) return null;

  const total = collection.reduce((sum, s) => sum + (s.price || 0), 0);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShowCollection(false)} />
      <div className="relative z-10 w-full max-w-[480px] max-h-[82vh] rounded-t-3xl bg-[#0e0e10] border-t border-white/10 flex flex-col">
        <div className="flex items-center justify-between px-5 pt-4 pb-3">
          <div className="flex items-center gap-2">
            <Library size={16} className="text-[#8b5cf6]" />
            <h3 className="text-[13px] font-semibold tracking-[0.16em] uppercase">My Collection</h3>
          </div>
          <button onClick={() => setShowCollection(false)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10">
            <X size={16} />
          </button>
        </div>

        {subscribed && (
          <div className="mx-5 mb-3 px-3 py-2 rounded-xl bg-amber-400/10 border border-amber-400/20 text-[12px] text-amber-200/90">
            Active member of {artist.name}'s exclusive membership.
          </div>
        )}

        <div className="overflow-y-auto px-3 pb-6 flex-1">
          {collection.length === 0 ? (
            <div className="flex flex-col items-center justify-center text-center py-16 px-8">
              <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-3">
                <ShoppingBag size={22} className="text-white/40" />
              </div>
              <p className="text-[14px] text-white/70 font-medium">Your collection is empty</p>
              <p className="text-[12px] text-white/40 mt-1">Buy a single to support the artist directly and add it here.</p>
            </div>
          ) : (
            collection.map((song) => {
              const isCurrent = current && current.id === song.id;
              const isPlaying = isCurrent && playing;
              return (
                <div key={song.id} className="flex items-center gap-3 px-2 py-2.5 rounded-xl hover:bg-white/[0.04]">
                  <div className="relative w-12 h-12 rounded-lg overflow-hidden shrink-0">
                    <img src={song.cover} alt={song.title} className="w-full h-full object-cover" />
                    <button onClick={() => playSong(song)} className="absolute inset-0 flex items-center justify-center bg-black/35 opacity-0 hover:opacity-100 transition-opacity">
                      {isPlaying ? <Pause size={16} /> : <Play size={16} />}
                    </button>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[14px] font-medium text-white truncate">{song.title}</p>
                    <p className="text-[11px] text-white/40">{`Purchased · $${(song.price || 0).toFixed(2)}`}</p>
                  </div>
                  <button onClick={() => playSong(song)} className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10">
                    {isPlaying ? <Pause size={15} /> : <Play size={15} />}
                  </button>
                </div>
              );
            })
          )}
        </div>

        {tickets && tickets.length > 0 && (
          <div className="px-3 pb-4">
            <p className="text-[11px] uppercase tracking-wide text-white/40 px-2 mb-1.5">Tickets</p>
            {tickets.map((t) => (
              <button key={t.token} onClick={() => setTicketQR(t)} className="w-full flex items-center gap-3 px-2 py-2.5 rounded-xl hover:bg-white/[0.04] text-left">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center shrink-0 ${t.expired ? "bg-white/5" : "bg-[#8b5cf6]/15"}`}>
                  <Ticket size={18} className={t.expired ? "text-white/30" : "text-[#a98bff]"} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[14px] font-medium text-white truncate">{t.event_title}</p>
                  <p className="text-[11px] text-white/40">{t.event_date} {t.expired ? "· Expired" : "· Tap to show QR"}</p>
                </div>
              </button>
            ))}
          </div>
        )}
          <div className="px-5 py-3 border-t border-white/10 flex items-center justify-between text-[13px]">
            <span className="text-white/50">{collection.length} owned</span>
            <span className="text-white font-semibold">Total spent ${total.toFixed(2)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
